'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMFontIcon = function WMFontIcon(_ref) {
	var children = _ref.children,
	    className = _ref.className,
	    color = _ref.color,
	    hoverColor = _ref.hoverColor,
	    id = _ref.id,
	    onMouseEnter = _ref.onMouseEnter,
	    onMouseLeave = _ref.onMouseLeave,
	    style = _ref.style;
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(
			_FontIcon2.default,
			{
				className: className,
				color: color,
				hoverColor: hoverColor,
				id: id,
				onMouseEnter: onMouseEnter,
				onMouseLeave: onMouseLeave,
				style: style
			},
			children
		)
	);
};

exports.default = WMFontIcon;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMFontIcon/index.js